import type { CaseStudy } from "./types";

const cs: CaseStudy = {
  slug: "lagos-fintech",
  founder: "Adaeze Okonkwo",
  company: "PayLink NG",
  city: "Lagos",
  country: "Nigeria",
  pillar: "bootcamp",
  outcomeShort: {
    en: "0 → €8k MRR in 90 days",
    fr: "0 → 8 k€ MRR en 90 jours",
  },
  title: {
    en: "How a Lagos fintech founder reached €8k MRR in 90 days",
    fr: "Comment une fondatrice fintech à Lagos a atteint 8 k€ de MRR en 90 jours",
  },
  subtitle: {
    en: "From idea to first 200 paying SMEs with the Bootpreneurs GTM bootcamp.",
    fr: "De l'idée aux 200 premières PME payantes avec le bootcamp GTM Bootpreneurs.",
  },
  body: {
    en: {
      context: "Adaeze had built a payment-link tool for Lagos market traders but couldn't get past 12 paying merchants in six months. The product worked; the GTM didn't.",
      challenge: "Distribution in informal markets is brutal — WhatsApp groups, market unions, and cash-first behaviours make standard SaaS playbooks useless.",
      approach: "She joined our Founder GTM bootcamp and rebuilt acquisition around three things: a 90-second WhatsApp demo loop, a market-union partnership program, and a one-page Naira pricing card.",
      outcome: "Within 90 days she crossed 200 merchants and €8,000 MRR. Her CAC dropped from €34 to €4 once the WhatsApp loop took over.",
      quote: "The bootcamp gave me a system, not a script. I now know what to do every Monday morning.",
      quoteAuthor: "Adaeze Okonkwo · Founder, PayLink NG",
    },
    fr: {
      context: "Adaeze avait construit un outil de lien de paiement pour les commerçants des marchés de Lagos mais ne dépassait pas 12 marchands payants en six mois. Le produit fonctionnait ; pas la stratégie GTM.",
      challenge: "La distribution dans les marchés informels est brutale — groupes WhatsApp, unions de marché, comportements cash-first rendent les playbooks SaaS standards inutiles.",
      approach: "Elle a rejoint notre bootcamp Founder GTM et a reconstruit l'acquisition autour de trois leviers : une boucle de démo WhatsApp de 90 secondes, un programme de partenariat avec les unions de marché, et une grille tarifaire d'une page en Naira.",
      outcome: "En 90 jours elle a franchi les 200 marchands et 8 000 € de MRR. Son CAC est passé de 34 € à 4 € une fois la boucle WhatsApp en place.",
      quote: "Le bootcamp m'a donné un système, pas un script. Je sais maintenant quoi faire chaque lundi matin.",
      quoteAuthor: "Adaeze Okonkwo · Fondatrice, PayLink NG",
    },
  },
  relatedBootcampSlug: "founder-gtm",
};
export default cs;
